import { render, staticRenderFns } from "./HmFilterBargain.vue?vue&type=template&id=5437d912&scoped=true&"
import script from "./HmFilterBargain.vue?vue&type=script&lang=js&"
export * from "./HmFilterBargain.vue?vue&type=script&lang=js&"
import style0 from "./HmFilterBargain.vue?vue&type=style&index=0&id=5437d912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437d912",
  null
  
)

component.options.__file = "HmFilterBargain.vue"
export default component.exports